import config from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async get_funciones({}, filtro = {}) {
      return await new Promise(async (resolve, reject) => {
        try {
          const params = new URLSearchParams({
            descripcion: filtro.descripcion || '',
            codigo: filtro.codigo || '',
            ruta_id: filtro.ruta_id ?? '',
            inhabilitado: filtro.inhabilitado ?? 0
          }).toString()
          const res = await fetch(`${config.API_URL}/funciones-nuevo/search?${params}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_funcion_by_id({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/funciones-nuevo/${id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async crear_funcion({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/funciones-nuevo`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({
              descripcion: payload.descripcion,
              codigo: payload.codigo,
              ruta_id: payload.ruta_id
            })
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async editar_funcion({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/funciones-nuevo/${payload.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({
              descripcion: payload.descripcion,
              codigo: payload.codigo,
              ruta_id: payload.ruta_id,
              inhabilitado: payload.inhabilitado ?? false
            })
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async eliminar_funcion({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/funciones-nuevo/${id}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_funciones_por_ruta({}, rutaId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/funciones-nuevo/ruta/${rutaId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_funciones_activas({}, rutaId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const params = rutaId ? `?ruta_id=${rutaId}` : ''
          const res = await fetch(`${config.API_URL}/funciones-nuevo/activos${params}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_funciones_sin_ruta({}) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/funciones-nuevo/sin-ruta`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
